import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Spin, Form, message, Button, Modal, notification } from "antd";
import { Col, Row } from "reactstrap";
import UiButton from "../../Common/UiButton/UiButton";
import useForm from "../../Common/hooks/useForm";
import approvedIcon from "../../../images/Approved.png";
import Completed from "../../../images/Completed.png";
import Failed from "../../../images/Failed.png";
import Incomplete from "../../../images/Incomplete.png";
import Inprogess from "../../../images/Inprogess.png";
import RejectIcon from "../../../images/rejecticon.png";
import { useLocation } from "react-router-dom";
import TextArea from "antd/lib/input/TextArea";
import {
  getESignDetails,
  getEsignDocument,
  saveESignTiggerDetails,
} from "../../../redux/RcuInfoEditPartner/action";

import { connect } from "react-redux";
import UseFullLoader from "../../FullPageLoader/UseFullLoader";
import useSession from "../../CustomLogout/useSession";
import DocumentUpoadInput from "./../../CompanyDocuments/NewUpload";
import { uploadDocuments } from "../../../redux/Documents/Upload/UploadDocumentsAction";
import { getRcuDocumentType } from "../../../redux/Documents/Get/GetDocumentsAction";
import ModalHeaderText from "../../../common/ModalHeaders/ModalHeaderText";
import {
  saveApprovalDetails,
  saveRejectDetails,
} from "../../../redux/VerificationInfoApproval/action";
import {
  getRejectAllDetails,
  getVerifactionAllDetails,
} from "../../../redux/VerificationInfoMaster/action";
import { useSelector } from "react-redux";

const ESign = (props) => {
  const handleSessionExpired = useSession();
  const { state, setState, onChangeTextHandler } = useForm();
  const [form] = Form.useForm();
  const FormItem = Form.Item;

  const testId = useSelector((state) => state?.auth?.checkLogin?.partnerFirmId);
  const location = useLocation();
  const id = location?.state?.partnerFirmId;

  console.log("object: ID", id, testId);

  const [loader, showLoader, hideLoader] = UseFullLoader();

  const loggedInRoleType = props.userData?.loggedInRoleType ?? "";

  const [eSignGetDataList, setESignGetDataList] = useState();
  const [disabledText, setDisabledText] = useState(false);
  const [approve, setApprove] = useState("");
  const [approveDate, setApproveDate] = useState("");
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [hideApproveBtn, setHideApproveBtn] = useState(true);
  const [documents, setDocuments] = useState([]);
  const [hideReject, setHideReject] = useState(true);
  const [rejectIcon, setRejectIcon] = useState(false);
  const [saveBtn, setSaveBtn] = useState(true);
  const [partnerDetatil, setPartnerDetail] = React.useState([]);
  const [RcuDocumentKey, setRcuDocumentKey] = React.useState(`${Date.now()}-1`);
  const [showText, setShowText] = useState(false);
  const [isRcuComplet, setRcuComplete] = useState(true);
  useEffect(() => {
    if (props?.activeKey == 7) {
      props
        .getRcuDocumentType({
          partnerFirmId: id,
          section: "ESIGN_DOCUMETS",
        })
        .then((res) => {
          if (res?.status === 200) {
            setPartnerDetail(res?.data?.dtoList[0]);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
      props
        .getESignDetails({
          access_token: props?.access_token,
          partnerFirmId: id,
        })
        .then((res) => {
          if (res?.status === 200) {
            setESignGetDataList(res?.data?.dto);
            setRcuComplete(res?.data?.dto?.isRcuFiCompleted);
          }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;
            hideLoader();

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              hideLoader();

              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });
      props
        .getVerifactionAllDetails(props.state.accessToken.access_token, id)
        .then((res) => {
          if (res?.status === 200)
            if (res?.data?.partnerFirmApprovedFlag == true) {
              setShowText(true);
              setDisabledText(true);
              setHideApproveBtn(false);
              setHideReject(false);
              setSaveBtn(false);
              setRejectIcon(false);
              setApprove(res?.data?.approveBy);
              setApproveDate(formatDateAp(res?.data?.approveOn));
              setLoading(false);
            } else {
              setLoading(false);
            }

          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });

      props
        .getRejectAllDetails(props.state.accessToken.access_token, id)
        .then((res) => {
          if (res?.status === 200)
            if (res.data?.partnerFirmStatus === "REJECTED") {
              setHideApproveBtn(false);
              setHideReject(false);
              setSaveBtn(false);
              setDisabledText(true);
              setRejectIcon(true);
              setLoading(false);
            }
          if (res?.data?.error || res.message) {
            const errorCode = res?.data?.error?.errorCode || res.errorCode;
            const errorMessage = res?.data?.error?.message || res.message;

            if (errorCode === "403" && res?.data?.error?.logoutStatus) {
              handleSessionExpired();
            } else {
              notification.error({
                description: errorMessage,
                duration: 5,
                placement: "top",
              });
            }
          }
        });

      handleGetDocument();
    }
  }, [props?.activeKey]);

  const handleChange = () => {
    showLoader();

    props
      .saveESignTiggerDetails({
        access_token: props?.access_token,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Triggered ESign Successfully ");
          hideLoader();
          props
            .getESignDetails({
              access_token: props?.access_token,
              partnerFirmId: id,
            })
            .then((res) => {
              if (res?.status === 200) {
                setESignGetDataList(res?.data?.dto);
              }
            });
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          hideLoader();

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            hideLoader();

            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      })
      .catch((e) => {
        hideLoader();
        // console.log("error", e);
      });
  };
  const [file, setFile] = React.useState({
    base64: "",
    docExt: "",
    docName: "",
  });
  const { setFieldsValue } = form;
  const [fileList, setFileList] = React.useState([]);
  const onFileRemove = () => {
    setFileList([], fileList);
  };
  const onFileSelect = (info) => {
    // setLoading(true);
    let fileArray = [];
    setFileList([]);
    getBase64(info, (result) => {
      let docExt;
      if (info.type === "image/jpeg") {
        docExt = "jpg";
      } else if (info.type === "image/png") {
        docExt = "png";
      } else if (info.type === "application/pdf") {
        docExt = "pdf";
      }
      const fileData = {
        name: info.name,
        uid: info.uid,
      };
      fileArray.push(fileData);
      setFileList(fileArray);
      setFile({
        base64: result,
        docExt: docExt,
        docName: info.name,
      });
      setFieldsValue({
        docFile: info.name,
      });
      let data = {
        partnerDocumentTypeId: 100,
        // optionSelected: null,
        fileName: info.name,
        section: "VERIFICATION_INFO_DOCUMENTS",
        partnerTeamId: null,
        documentDetails: {
          base64: `${result}`,
          docTypeId: "1581",
          docExt: `${docExt}`,
        },
      };

      props.uploadDocuments({
        data,
        partnerFirmId: id,
      });
    });
  };
  const getBase64 = (file, cb) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {};
  };

  const onChange = (info) => {
    // console.log(info);
  };
  const showModal = () => {
    setIsModalVisible(true);
    // form.resetFields();
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    form.resetFields();
  };
  const [disabledBtn, setDisabledBtn] = useState(false);

  const handleReject = (e) => {
    e.stopPropagation();
    // psetLoading(true);
    let values = {
      deactiveReason: state.RejectionReason?.trim(),
    };
    props
      .saveRejectDetails({
        access_token: props.access_token,
        partnerFirmId: id,
        data: values,
      })
      .then((res) => {
        // setLoading(false);
        if (res && res.status === 200) {
          setIsModalVisible(false);
          message.success("Partner is deactivated");
          setShowText(false);
          setHideApproveBtn(false);
          setSaveBtn(false);
          setHideReject(false);
          setDisabledText(true);
          setRejectIcon(true);
          setLoading(false);
          props.getRejectAllDetails(props.state.accessToken.access_token, id);
          props.getProgress({ partnerFirmId: id });

          // setShowText(true);
          // props.getVerifactionMasterDetails(
          //   props.state.accessToken.access_token,
          //   props.firmId
          // );
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  };
  const rejectedBy =
    props.verificationMasterList?.rejectDetails?.data?.rejectedBy;
  const rejectedOn =
    props.verificationMasterList?.rejectDetails?.data?.rejectedOn;
  const rejectedReason =
    props.verificationMasterList?.rejectDetails?.data?.rejectedReason;

  const timestamp = new Date(rejectedOn);

  const formatDate = (timestamp) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(timestamp).toLocaleDateString(undefined, options);
  };

  const datatime = formatDate(timestamp);

  const approveBy =
    props.verificationMasterList?.verificationDetails?.data?.approveBy;

  const approveOn =
    props.verificationMasterList?.verificationDetails?.data?.approveOn;

  const formatDateAp = (approveOn) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(approveOn).toLocaleDateString(undefined, options);
  };

  let handleGetDocument = (partnerDocumentTypeId) => {
    console.log("line 378 called");
    props
      .getEsignDocument({
        partnerFirmId: id,
        accessToken: props.accessToken,
      })
      .then((res) => {
        if (res?.status == 200 && res?.data?.dto) {
          setDocuments([
            {
              partnerDocumentTypeId: res?.data?.dto?.partnerDocumentTypeId,
              url: res?.data?.dto?.documentLink,
              status: "done",
              uid: res?.data?.dto?.uuid,
              name: res?.data?.dto?.fileName ?? "View Document",
            },
          ]);

          setRcuDocumentKey(`${Date.now()}-1`);
          props
            .getESignDetails({
              access_token: props?.access_token,
              partnerFirmId: id,
            })
            .then((res) => {
              if (res?.status === 200) {
                setESignGetDataList(res?.data?.dto);
                setRcuComplete(res?.data?.dto?.isRcuFiCompleted);
              }
              if (res?.data?.error || res.message) {
                const errorCode = res?.data?.error?.errorCode || res.errorCode;
                const errorMessage = res?.data?.error?.message || res.message;
                hideLoader();

                if (errorCode === "403" && res?.data?.error?.logoutStatus) {
                  hideLoader();

                  handleSessionExpired();
                } else {
                  notification.error({
                    description: errorMessage,
                    duration: 5,
                    placement: "top",
                  });
                }
              }
            });
        }
      });
  };

  const handleChangeVerifaction = () => {
    if (isModalVisible) {
      return;
    }
    setLoading(true);
    props
      .saveApprovalDetails({
        access_token: props.access_token,
        partnerFirmId: id,
      })
      .then((res) => {
        if (res && res.status === 200) {
          message.success("Saved");
          setShowText(true);
          setHideApproveBtn(false);
          setSaveBtn(false);
          setHideReject(false);
          setSaveBtn(false);
          setDisabledText(true);
          setRejectIcon(false);
          setApprove(res.data.approveBy);
          setApproveDate(formatDateAp(res.data.approveOn));
          setLoading(false);
          props.getProgress({ partnerFirmId: id });

          // props.getVerifactionMasterDetails(
          //   props.state.accessToken.access_token,
          //   props.firmId
          // );
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;
          setLoading(false);

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }

        // if (res?.data?.error) {
        //   message.error(res?.data?.error?.message, 5);
        //   setLoading(false);
        // }
      });
  };
  const ForVerification =
    props.editPartner?.status === "FOR_VERIFICATION" ? true : false;

  console.log("line 381", props.editPartner?.status);

  return (
    <div>
      {loader}
      <Modal
        open={isModalVisible}
        closable={false}
        className="modal-container"
        centered
        footer={null}
      >
        {" "}
        <Row>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col md={12} className="headre-login">
              <ModalHeaderText LoginHeading="Reject Partner" />
            </Col>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col md={12}>
            <p>
              By Clicking on confirm, the partner will be rejected and will not
              be able to add leads into the system. However his earlier leads
              will still be active and accessible to the Avanse Teams.
            </p>
          </Col>
        </Row>
        <Row className="form-group">
          <Col md={12}>
            <TextArea
              type="text"
              title="Reason of Activated"
              id="reasonOfDeactivation"
              maxLength={255}
              placeholder="Enter Reason of Activation"
              autoComplete="off"
              className="floating-input floating-textarea"
              rows={4}
              validation={[
                {
                  required: true,
                  message: "Please Enter Reason of Activation",
                },
              ]}
              name="RejectionReason"
              onChange={onChangeTextHandler}
            />
          </Col>
        </Row>
        <Row className="">
          <Col md={12} className="d-flex justify-content-end">
            <Button
              className="mr-3"
              htmlType="text-btn-sec"
              type="default"
              onClick={handleCancel}
            >
              CANCEL
            </Button>
            <Button
              onClick={(e) => {
                handleReject(e);
              }}
              className=""
              htmlType="text-btn-sec"
              type="primary"
            >
              CONFIRM
            </Button>
          </Col>
        </Row>
      </Modal>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <Row>
          <Col sm={2} className="left-side-tabs">
            <Nav variant="pills" className="flex-column">
              <Nav.Item>
                <Nav.Link eventKey="first">
                  <div className="tab-selet-test">
                    <h4>E Sign</h4>
                  </div>
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Col>
          <Col sm={10}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <Form
                  autoComplete="off"
                  name="verficationInfo"
                  form={form}
                  onFinish={handleChange}
                >
                  <Row>
                    <Col md={12} className="RCU-INFO-sec">
                      <Row>
                        <Col md={12}>
                          <>
                            <div className="triiger-e-sgn-option">
                              {eSignGetDataList?.esignStatus === "COMPLETED" ||
                              loggedInRoleType === "RM" ||
                              rejectIcon ? (
                                ""
                              ) : (
                                <h2>Send Document for E-Sign</h2>
                              )}

                              {loggedInRoleType === "RM" ||
                              loggedInRoleType === "PARTNER" ||
                              eSignGetDataList?.esignStatus === "COMPLETED" ||
                              eSignGetDataList?.esignStatus === "IN_PROGRESS" ||
                              eSignGetDataList?.esignStatus !== null ||
                              rejectIcon ? (
                                ""
                              ) : (
                                <UiButton
                                  type="submit"
                                  title="Trigger E-Sign"
                                  disabled={
                                    eSignGetDataList?.esignStatus ===
                                      "IN_PROGRESS" ||
                                    !isRcuComplet ||
                                    !ForVerification
                                      ? true
                                      : false
                                  }
                                />
                              )}

                              <div className="icon-sec-es">
                                {eSignGetDataList?.esignStatus ===
                                  "IN_PROGRESS" && !rejectIcon ? (
                                  <img
                                    className="verifi-ic-btn"
                                    src={Inprogess}
                                    alt=""
                                  />
                                ) : null}
                                {eSignGetDataList?.esignStatus === null &&
                                !rejectIcon ? (
                                  <img
                                    className="verifi-ic-btn"
                                    src={Incomplete}
                                    alt=""
                                  />
                                ) : null}

                                {eSignGetDataList?.esignStatus === "FAILED" &&
                                !rejectIcon ? (
                                  <img
                                    className="verifi-ic-btn"
                                    src={Failed}
                                    alt=""
                                  />
                                ) : null}
                              </div>
                            </div>
                          </>
                        </Col>
                      </Row>
                      {eSignGetDataList?.esignStatus === "COMPLETED" ? (
                        <Col md={4} className="">
                          {eSignGetDataList?.auditTrailDocumentLink &&
                            eSignGetDataList?.esignDocumentLink &&
                            !rejectIcon && (
                              <Row>
                                <Col md={8}>
                                  <h3 className="list-name-se">
                                    E-Signed Document List
                                  </h3>

                                  <li>
                                    <a
                                      target="_blank"
                                      href={eSignGetDataList?.esignDocumentLink}
                                    >
                                      E-Sign DocumentLink
                                    </a>
                                  </li>
                                  <li>
                                    <a
                                      target="_blank"
                                      href={
                                        eSignGetDataList?.auditTrailDocumentLink
                                      }
                                    >
                                      Audit Trail DocumentLink
                                    </a>
                                  </li>
                                </Col>
                                <Col md={4}>
                                  <img
                                    className="verifi-ic-btn"
                                    src={Completed}
                                    alt=""
                                  />
                                </Col>
                              </Row>
                            )}

                          {documents.length > 0 &&
                            documents[0]?.url &&
                            !rejectIcon && (
                              <Row>
                                <Col md={8}>
                                  <h3 className="list-name-se">
                                    Signed physical Document
                                  </h3>
                                  <li>
                                    <a target="_blank" href={documents[0]?.url}>
                                      {documents[0]?.name}
                                    </a>
                                  </li>
                                </Col>
                                <Col md={4}>
                                  <img
                                    className="verifi-ic-btn"
                                    src={Completed}
                                    alt=""
                                  />
                                </Col>
                              </Row>
                            )}
                        </Col>
                      ) : null}
                      {rejectIcon ||
                      showText ||
                      loggedInRoleType !== "CET" ||
                      eSignGetDataList?.esignStatus === "COMPLETED" ? (
                        ""
                      ) : (
                        <>
                          <h3 className="or-option">--OR--</h3>
                          <Row>
                            <Col
                              md={12}
                              className="ruc-document-sec new-phycsal"
                            >
                              <h4>Upload Physical</h4>
                              <div>
                                <DocumentUpoadInput
                                  disabled={
                                    !isRcuComplet || !ForVerification
                                      ? true
                                      : false
                                  }
                                  listType="picture"
                                  className="selected-optdoc rcu"
                                  key={RcuDocumentKey}
                                  setDisabled={() => {}}
                                  type="Button"
                                  getRcuDocuments={handleGetDocument}
                                  partnerFirmId={id}
                                  progress={{
                                    strokeWidth: 0,
                                    showInfo: false,
                                  }}
                                  item={{
                                    partnerDocumentTypeId:
                                      partnerDetatil?.partnerDocumentTypeId,
                                    dmsDocTypeId: partnerDetatil?.dmsDocTypeId,
                                    section: partnerDetatil?.section,
                                  }}
                                  showUploadList={{
                                    showRemoveIcon: false,
                                  }}
                                  accept=".pdf,.png,.jpg"
                                  beforeUpload={(e) => onFileSelect(e)}
                                  onRemove={onFileRemove}
                                  defaultFileList={documents}
                                  // maxCount={1}
                                  onChange={onChange}
                                  // defaultFileList={documents}
                                />
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}

                      {(loggedInRoleType === "CET") |
                        (loggedInRoleType === "RM") && (
                        <>
                          <Row>
                            {rejectIcon ? (
                              <Col
                                lg={12}
                                xs={12}
                                md={12}
                                sm={12}
                                className="inner-field-right"
                              >
                                <Col md={4} className="">
                                  <div className="text-reject">
                                    <div className="sec-text">
                                      <h3>Rejected By</h3>
                                      <h4>{rejectedBy}</h4>
                                    </div>
                                  </div>
                                </Col>
                                <Col md={5} className="">
                                  <div className="text-reject">
                                    <div className="sec-text">
                                      <h3>Rejected On</h3>
                                      <h4>{datatime ? datatime : "----"}</h4>
                                    </div>
                                  </div>
                                </Col>
                              </Col>
                            ) : null}
                          </Row>
                          {rejectIcon ? (
                            <>
                              <Row>
                                <Col
                                  lg={12}
                                  xs={12}
                                  md={12}
                                  sm={12}
                                  className="inner-field-right"
                                >
                                  <Col md={4} className="">
                                    <div className="text-reject par-sec">
                                      <div className="sec-text">
                                        <h3>Rejected Reason</h3>
                                        <h4>{rejectedReason}</h4>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4} className=""></Col>

                                  <Col md={4} className="">
                                    <img
                                      className="verifi-ic-btn"
                                      src={RejectIcon}
                                      alt=""
                                    />
                                  </Col>
                                </Col>
                              </Row>
                            </>
                          ) : null}{" "}
                          {showText ? (
                            <>
                              <Row>
                                <Col
                                  lg={12}
                                  xs={12}
                                  md={12}
                                  sm={12}
                                  className="inner-field-right"
                                >
                                  <Col md={4} className="">
                                    <div className="text-reject">
                                      <div className="sec-text">
                                        <h3>Approved By</h3>
                                        <h4>{approve}</h4>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4} className="">
                                    <div className="text-reject">
                                      <div className="sec-text">
                                        <h3>Approved On</h3>
                                        <h4> {approveDate}</h4>
                                      </div>
                                    </div>
                                  </Col>
                                </Col>
                              </Row>
                              <Row>
                                <Col
                                  lg={12}
                                  xs={12}
                                  md={12}
                                  sm={12}
                                  className="inner-field-right"
                                >
                                  <Col md={4} className=""></Col>
                                  <Col md={4} className=""></Col>
                                  <Col md={4} className="">
                                    <img
                                      className="verifi-ic-btn"
                                      src={approvedIcon}
                                      alt=""
                                    />
                                  </Col>
                                </Col>
                              </Row>
                            </>
                          ) : null}
                          <Row>
                            <Col
                              lg={12}
                              xs={12}
                              md={12}
                              sm={12}
                              className="inner-field-right"
                            >
                              <Col md={12}>
                                {loading && (
                                  <div className="pr-4 spanner">
                                    {/* <Spin
                                  size="large"
                                  className="pr-4"
                                  indicator={
                                    <LoadingOutlined
                                      style={{ color: "#00d8db" }}
                                    />
                                  }
                                ></Spin> */}
                                  </div>
                                )}

                                <>
                                  <div className="d-flex verify-btn-reject">
                                    {hideApproveBtn &&
                                    loggedInRoleType == "CET" &&
                                    eSignGetDataList?.esignStatus ===
                                      "COMPLETED" ? (
                                      <UiButton
                                        onClick={handleChangeVerifaction}
                                        type="text-btn-sec"
                                        title="Approve"
                                      />
                                    ) : null}

                                    {hideReject && loggedInRoleType == "CET" ? (
                                      <div className="btn-sec-reject">
                                        <UiButton
                                          onClick={showModal}
                                          className="text-btn-sec"
                                          title="Reject"
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                </>
                              </Col>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Col>
                  </Row>
                </Form>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveESignTiggerDetails: (data) => dispatch(saveESignTiggerDetails(data)),
    getESignDetails: (data) => dispatch(getESignDetails(data)),
    uploadDocuments: (user) => dispatch(uploadDocuments(user)),
    getRcuDocumentType: (user) => dispatch(getRcuDocumentType(user)),
    saveRejectDetails: (data) => dispatch(saveRejectDetails(data)),
    getRejectAllDetails: (accessToken, partnerFrimID) =>
      dispatch(getRejectAllDetails(accessToken, partnerFrimID)),
    getVerifactionAllDetails: (accessToken, partnerFrimID) =>
      dispatch(getVerifactionAllDetails(accessToken, partnerFrimID)),
    getEsignDocument: (data) => dispatch(getEsignDocument(data)),
    saveApprovalDetails: (data) => dispatch(saveApprovalDetails(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    userData: state?.auth?.userData,
    editPartner: state?.editPartner?.editPartner,
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    verificationMasterList: state.verificationMasterList,

    editPartner: state.editPartner.editPartner,
    firmId:
      state.auth?.checkLogin?.partnerFirmId ||
      state?.auth?.loginCredentials?.data?.partnerFirmDetails?.partnerFirmId ||
      sessionStorage.getItem("cetFirmId"),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ESign);
